import ajax from './ajax'

const Base = 'api'

//delete room type images file
export const reqDeleteRoomTypeImage = (imageId) => ajax(Base + '/files/room-types/image/' + imageId, {}, 'DELETE')

export const reqVapidPublicKey = () => ajax(Base + '/push-subscriptions/vapid-public-key', {}, 'GET', {"Content-Type": "application/json"})

export const reqRegisterPushSubscription = (body) => ajax(Base + '/push-subscriptions', body, 'POST', {"Content-Type": "application/json"})

export const reqRemovePushSubscription = (subscriptionId) => ajax(Base + '/push-subscriptions/' + subscriptionId, {}, 'DELETE')